var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90234 6.03372L4.47019 3.60156L6.90234 1.16941C7.14122 0.930536 7.14122 0.539654 6.90234 0.300781C6.66347 0.0619091 6.27259 0.0619091 6.03372 0.300781L3.60156 2.73294L1.16941 0.300781C0.930535 0.0619091 0.539653 0.0619091 0.300781 0.300781C0.0619087 0.539654 0.0619087 0.930536 0.300781 1.16941L2.73294 3.60156L0.300781 6.03372C0.0619087 6.27259 0.0619091 6.66347 0.300781 6.90234C0.539654 7.14122 0.930535 7.14122 1.16941 6.90234L3.60156 4.47019L6.03372 6.90234C6.27259 7.14122 6.66347 7.14122 6.90234 6.90234C7.14122 6.66347 7.14122 6.27259 6.90234 6.03372Z",
    fill: "#E63335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/Remove.bf6632c78fdc52b5d8ba6afda6b9da29.svg";
export { ForwardRef as ReactComponent };